<script setup lang="ts">
    import { useAiAssistantStore } from '~/stores/aiAssistantStore';
    import { ENTITY_ICON_MAP, ENTITY_LABEL_KEY_MAP } from '~/utils/aiEntityMeta';

    const { t } = useTranslation();
    const store = useAiAssistantStore();

    const props = defineProps<{
        type: string;
        id: string;
        title: string | null;
    }>();

    const openPreview = () => {
        store.openPreview(props.type, props.id);
    };

    const typeIcon = computed(() => ENTITY_ICON_MAP[props.type] ?? 'fa-regular fa-file');
    const typeLabel = computed(() => t(ENTITY_LABEL_KEY_MAP[props.type] ?? 'ai.entity.document'));

    const isYellowKind = computed(() => ['worksite', 'quote', 'order_slip', 'delivery_slip'].includes(props.type));
</script>

<template>
    <button
        type="button"
        class="group inline-flex items-center gap-2 self-start min-w-[200px] px-[10px] py-[7px] pr-[12px] rounded-[8px] border bg-white transition-colors shadow-[0_1px_2px_rgba(15,16,32,0.04)] border-[#E7E7E7] hover:border-[#E8B102] hover:bg-[#FFFBEA] cursor-pointer"
        @click="openPreview"
    >
        <span
            class="w-[22px] h-[22px] flex-shrink-0 rounded-full flex items-center justify-center"
            :class="isYellowKind
                ? 'bg-branding-brand-yellow/90 text-black border border-[#E8B102]'
                : 'bg-[#EEF2F7] text-gray-600 border border-[#E7E7E7]'"
        >
            <i :class="typeIcon" class="text-[10px]" />
        </span>
        <span class="font-inter text-[12.5px] font-semibold text-gray-900 leading-tight truncate flex-1 min-w-0 text-left">
            {{ title ?? $t('ai.artifact.deleted') }}
        </span>
        <span class="font-inter text-[11px] text-gray-400 leading-tight flex-shrink-0">
            · {{ typeLabel }}
        </span>
        <i
            class="fa-solid fa-arrow-right text-[10px] text-gray-400 ml-1 group-hover:text-gray-600 flex-shrink-0"
        />
    </button>
</template>
